import React from 'react'

export const Liquid1 = (props: any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="470.857" height="381.952" viewBox="0 0 470.857 381.952" {...props}>
      <path id="Path_41" data-name="Path 41" d="M716.664,104.658c-9.954-20.59-28.854-37.867-51.49-41.127C637.808,59.59,611.808,76.04,590.8,94.011s-41.127,38.876-67.585,46.9c-47.327,14.346-96.321-16.986-145.772-17.3a118.526,118.526,0,0,0-86.408,37.317c-81.915,88.1-.21,229.483,93.647,268.294,75.775,31.332,166.563,13.628,232.873-34.608C680.8,348.594,719.751,267.827,726.99,189.919q.855-9.182,1.118-18.288C728.761,148.771,726.62,125.246,716.664,104.658Z" transform="translate(-257.358 -62.942)" fill="rgba(255,255,255,0.11)" />
    </svg>
  )
}
